import React, { useEffect, useState } from 'react';
import { ArrowLeft, Save,} from 'lucide-react';
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import { getLoadPlanByID } from '@/redux/Load/actions';
import { SearchBar } from '../SearchBox/SearchBar';
import FileUpload from '../FileUpload/FileUpload';
import { updateLoadPlan } from '@/redux/Load/actions';
import { getAddressAPI } from '@/redux/Purchase/actions';
import { callLoader } from '@/redux/Loader/actions';
import { getItemColumns } from './columns';
import { DataTable } from '../ui/table';
import DatePicker from 'react-datepicker';
import { showToast } from '@/redux/Toast/actions';
import CelebrationButton from '../ui/CelebrationButton/CelebrationButton';

const LoadPlanEditForm = ({ onBack, orderDataId = null }) => {

    const dispatch = useDispatch();
    const { countryList,  incoTermsList, quantityTypeList,uomTypeList } = useSelector((state) => state.common);
    const [formData, setFormData] = useState();
    const [items, setItems] = useState([]);

    const { isAnimate } = useSelector((state) => state.toast);


    useEffect(() => {
        if (orderDataId != 0 && orderDataId != null) {
            _getLoadPlan();
        } else {
            _setNewLoadPlan();
        }
    }, [orderDataId])

    const _getLoadPlan = () => {
        dispatch(callLoader(1))
        getLoadPlanByID(orderDataId).then(res => {
              dispatch(callLoader(0))
            setFormData(res);
            setItems(res?.lineItems ?? []);
        }).catch(err => {
           
              dispatch(callLoader(0))
        });

    }

    const _setNewLoadPlan = async () => {
        setFormData(null);
        setItems([])
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleItemChange = (index, field, value) => {
        const updated = [...items];
        updated[index][field] = value;
        if (field === 'quantity' || field === 'price') {
            const qty = parseFloat(updated[index].quantity) || 0;
            const price = parseFloat(updated[index].price) || 0;
            updated[index].total = (qty * price).toFixed(2);
        }
        console.log(updated);
        setItems(updated);
    };


    const formhandleSubmit = async (e) => {
        e.preventDefault();
    }

    const _setAddress = async (type, id) => {
        const address = await getAddressAPI(id);
        setFormData(prev => ({ ...prev, [`${type}`]: address }));
    };

    const handleSubmit = async (e) => {
        console.log('Form Data:', formData, 'Items:', items);
        try {
            var itmPayload = [];
            items.map((v, i) => {
                const ob = {
                    "LOADPLAN_LINEITEM_ID": v?.loadplanLineitemId ?? 0,
                    "SKU": v?.sku,
                    "SKU_ITEM_DESC": v?.skuItemDesc,
                    "UOT": v?.uot,
                    "CASES_PER_UOT": v?.casesPerUot,
                    "GROSS_WEIGHT_KGS": v?.grossWeightKgs,
                    "NET_WEIGHT_KGS": v?.netWeightKgs,
                    "PACKING": v?.packing,
                    "QUANTITY": v?.quantity,
                    "METRIC_ID": v?.metricId,
                    "METRIC_TYPE": v?.metricType,
                    "PRICE": v?.price,
                    "SO_NUMBER": v?.soNumber,
                    "PO_NUMBER": v?.poNumber,
                    "IS_ACTIVE": v?.isActive != false ? true : false
                }
                v?.sku ? itmPayload.push(ob) : null;
            });
            const payload = {
                "LO_ID": formData?.loId ?? 0,
                "COMPANY_ID": 1,
                "LO_DATE": formData?.loDate ? moment(formData?.loDate).format('YYYY-MM-DD') : null,
                "LO_SHIP_BY_DATE": formData?.loShipByDate ? moment(formData?.loShipByDate).format('YYYY-MM-DD') : null,
                "CUSTOMER_ID": formData?.customerId,
                "CUSTOMER": formData?.customer,
                "CUSTOMER_ADDRESS": formData?.customerAddress,
                "CONSIGNEE_ID": formData?.consigneeId,
                "CONSIGNEE": formData?.consignee,
                "CONSIGNEE_ADDRESS": formData?.consigneeAddress,
                "INCOTERM_ID": formData?.incotermId,
                "INCOTERM": formData?.incoterm,
                "DESTINATION_COUNTRY": formData?.destinationCountry,
                "WAREHOUSE_ID": formData?.warehouseId,
                "WAREHOUSE": formData?.warehouse,
                "WAREHOUSE_ADDRESS": formData?.warehouseAddress,
                "WAREHOUSE_REMARK": formData?.warehouseRemark,
                "INTERNAL_REMARKS": formData?.internalRemarks,
                "MODIFIED_BY": "Admin",
                "IS_ACTIVE": formData?.isActive != false ? true : false,
                "LineItems": itmPayload
            }

            if (orderDataId != 0 && orderDataId != null) {
                     dispatch(callLoader(1));
                const updateDetails = await updateLoadPlan(payload);
                 dispatch(callLoader(0));
                if (updateDetails?.message) {
                       dispatch(showToast("Load Plan saved successfully", "success", true))
                            
                } else {
                    throw new Error('Load Plan Not Updated!');
                }
            } else {
                throw new Error('Load Plan Not Updated!');
            }
        } catch (error) {
             dispatch(showToast(error?.message || error,  "error"));
              dispatch(callLoader(0));
        }
    };

    const columns = getItemColumns({
  items,
  handleItemChange,
  uomTypeList,
  quantityTypeList,
});

    return (
      <div className="h-full bg-slate-50 dark:bg-slate-950">
        <div className="mx-auto p-4">
          {/* Compact Header */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <button
                onClick={onBack}
                className="p-2 hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg transition-colors"
              >
                <ArrowLeft className="w-5 h-5 text-slate-600 dark:text-slate-400" />
              </button>
              <div>
                <h1 className="text-xl font-bold text-slate-900 dark:text-white">
                  {orderDataId ? "Edit Load Plan" : "New Load Plan"}
                </h1>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  {orderDataId
                    ? `Editing ${orderDataId}`
                    : "Create a new load plan order"}
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <button
                type="button"
                onClick={onBack}
                className="px-4 py-2 text-sm text-slate-600 dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg transition-all"
              >
                Cancel
              </button>
              <CelebrationButton
                onClick={() => handleSubmit()}
                label={"Save Plan"}
                className="px-4 py-2 text-sm bg-[#0072FF] hover:bg-[#0062DD] text-white rounded-lg font-medium transition-all flex items-center space-x-1"
                icon={<Save className="w-4 h-4" />}
                isSuccess={isAnimate}
              />
            </div>
          </div>

          <form id="po-form" onSubmit={formhandleSubmit} className="space-y-4">
            {/* Order Details Section */}
            <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 p-4">
              <h2 className="text-sm font-semibold text-slate-900 dark:text-white mb-3">
                Order Details
              </h2>
              <div className="grid grid-cols-4 gap-3">
                <div className="">
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Load Plan # <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="loNumber"
                    value={formData?.loNumber}
                    readOnly
                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                  />
                </div>
                <div className="">
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    LP SO # <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="loSoNumber"
                    value={formData?.loSoNumber}
                    readOnly
                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Inco Terms
                  </label>
                  <select
                    name="incotermId"
                    value={formData?.incotermId}
                    onChange={(d) => {
                      handleInputChange({
                        target: { name: "incotermId", value: d.target.value },
                      });
                      handleInputChange({
                        target: {
                          name: "incoterm",
                          value: d.target.options[d.target.selectedIndex].text,
                        },
                      });
                    }}
                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                  >
                    <option value="">SELECT TERMS</option>
                    {incoTermsList?.map((term, key) => (
                      <option key={key} value={term?.id}>
                        {term?.incoterm}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Date
                  </label>
                  <DatePicker
                    selected={
                      formData?.loDate ? new Date(formData.loDate) : null
                    }
                    showIcon
                    onChange={(date) =>
                      handleInputChange({
                        target: {
                          name: "loDate",
                          value: moment(date).format("YYYY-MM-DD"),
                        },
                      })
                    }
                    dateFormat="dd MMM yyyy" //
                    placeholderText="Select Date"
                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                  />
                </div>
              </div>
            </div>

            {/* Trade Partner Section */}
            <div className="grid grid-cols-3 gap-4">
              <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 p-4 col-span-2">
                <h2 className="text-sm font-semibold text-slate-900 dark:text-white mb-3">
                  Trade Partner
                </h2>
                <div className="grid grid-cols-2 gap-6">
                  {/* Left Column - Vendor */}
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Customer <span className="text-red-500">*</span>
                    </label>
                    <SearchBar
                      searchAPI={
                        "v1/AutoSuggestion/GetVendorSuggestion?Prefix="
                      }
                      selectReacord={(d) => {
                        handleInputChange({
                          target: { name: "customer", value: d?.[1] },
                        });
                        handleInputChange({
                          target: { name: "customerId", value: d?.[0] },
                        });
                        _setAddress("customerAddress", d?.[0]);
                      }}
                      value={formData?.customer}
                    />
                    <textarea
                      name="customerAddress"
                      value={formData?.customerAddress}
                      onChange={handleInputChange}
                      rows="2"
                      className="w-full mt-2 px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] resize-none"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Consignee
                    </label>
                    <SearchBar
                      searchAPI={
                        "v1/AutoSuggestion/GetConsigneeSuggestion?Prefix="
                      }
                      selectReacord={(d) => {
                        handleInputChange({
                          target: { name: "consignee", value: d?.[1] },
                        });
                        handleInputChange({
                          target: { name: "consigneeId", value: d?.[0] },
                        });
                        _setAddress("consigneeAddress", d?.[0]);
                      }}
                      value={formData?.consignee}
                    />
                    <textarea
                      name="consigneeAddress"
                      value={formData?.consigneeAddress}
                      onChange={handleInputChange}
                      rows="2"
                      className="w-full mt-2 px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] resize-none"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Warehouse
                    </label>
                    <SearchBar
                      searchAPI={
                        "v1/AutoSuggestion/GetWarehouseSuggestion?Prefix="
                      }
                      value={formData?.warehouse}
                      selectReacord={(d) => {
                        handleInputChange({
                          target: { name: "warehouse", value: d?.[1] },
                        });
                        handleInputChange({
                          target: { name: "warehouseId", value: d?.[0] },
                        });
                        _setAddress("warehouseAddress", d?.[0]);
                      }}
                    />
                    <textarea
                      name="warehouseAddress"
                      value={formData?.warehouseAddress}
                      onChange={handleInputChange}
                      rows="2"
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] resize-none mt-2"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Remarks
                    </label>
                    <textarea
                      name="internalRemarks"
                      value={formData?.internalRemarks}
                      onChange={handleInputChange}
                      rows="3"
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] resize-none"
                    />
                  </div>
                </div>
              </div>
              <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 p-4">
                <h2 className="text-sm font-semibold text-slate-900 dark:text-white mb-3">
                  Routing
                </h2>
                <div className="grid grid-cols-1 gap-6">
                  {/* Left Column - Vendor */}
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Delivered By Date
                    </label>

                    <DatePicker
                      selected={
                        formData?.loShipByDate
                          ? new Date(formData.loShipByDate)
                          : null
                      }
                      showIcon
                      onChange={(date) =>
                        handleInputChange({
                          target: {
                            name: "loShipByDate",
                            value: moment(date).format("YYYY-MM-DD"),
                          },
                        })
                      }
                      dateFormat="dd MMM yyyy" //
                      placeholderText="Select Date"
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Dest. Country
                    </label>
                    <select
                      name="destinationCountry"
                      value={formData?.destinationCountry}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                    >
                      <option value="">SELECT COUNTRY OF DESTINATION</option>
                      {countryList?.map((country, key) => (
                        <option key={key} value={country.incoterm}>
                          {country.incoterm}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Commodity Table */}
            <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 ">
              <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 dark:border-slate-800">
                <h2 className="text-sm font-semibold text-slate-900 dark:text-white">
                  Commodity
                </h2>
              </div>

              <DataTable
                data={items.filter((i) => i?.isActive !== false)}
                columns={columns}
                tdClass="px-2 py-2"
                thClass="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400"
                trClass="hover:bg-slate-50 dark:hover:bg-slate-800/30"
                htrClass="border-b border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50"
                boxClass="overflow-x-auto overflow-y-visible pb-[20vh] text-xs"
              />
            </div>

            {/* Upload Documents Section */}
            {orderDataId != 0 && orderDataId != null && (
              <>
                <FileUpload
                  orderId={orderDataId}
                  orderNum={formData?.loNumber}
                  type={"loadplan"}
                />
              </>
            )}
          </form>
        </div>
      </div>
    );
};

export default LoadPlanEditForm;
